(function () {
    var sortableTable = {
        $table: null,
        $tbody: null,

        init: function () {
            sortableTable.$table = $('.table--sortable');
            sortableTable.control();
            sortableTable.sortIt();
        },
        control: function () {
            //grab all header rows
            sortableTable.$table.find('th.sortable').each(function (column) {
                var $this = $(this);
                let ariaLabel = $this.attr('aria-label');
                column = $this.index();

                $this.addClass('sort-default').click(function () {
                    let asc = $this.closest('.table--sortable').data('asc'),
                        desc = $this.closest('.table--sortable').data('desc');
                    var isDate = false;
                    var findSortKey = function ($cell) {
                        return $cell.find('.sort-key').text().toUpperCase().length
                            ? $cell.find('.sort-key').text().toUpperCase()
                            : $cell.text().toUpperCase();
                    };
                    var sortDirection = $this.is('.sorted-asc') ? -1 : 1;
                    var $tbody = $this.closest('.table--sortable').find('tbody');
                    var $rows = $this.closest('.table--sortable').find('tbody tr').get();
                    //loop through all the rows and find
                    $.each($rows, function (index, row) {
                        var $element = $(row).children('td').eq(column);
                        row.sortKey = findSortKey($element);
                        if ($element.data('text') === 'date') {
                            isDate = true;
                        }
                    });

                    //compare and sort the rows alphabetically or numerically
                    $rows.sort(function (a, b) {
                        if (a.sortKey.indexOf('-') === -1 && !isNaN(a.sortKey) && !isNaN(a.sortKey)) {
                            //Rough Numeracy check

                            if (parseInt(a.sortKey) < parseInt(b.sortKey)) {
                                return -sortDirection;
                            }
                            if (parseInt(a.sortKey) > parseInt(b.sortKey)) {
                                return sortDirection;
                            }
                        } else if (isDate === true) {
                            if (Date.parse(a.sortKey) < Date.parse(b.sortKey)) {
                                return -sortDirection;
                            }
                            if (Date.parse(a.sortKey) > Date.parse(b.sortKey)) {
                                return sortDirection;
                            }
                        } else {
                            if (a.sortKey < b.sortKey) {
                                return -sortDirection;
                            }
                            if (a.sortKey > b.sortKey) {
                                return sortDirection;
                            }
                        }
                        return 0;
                    });
                    //add the rows in the correct order to the bottom of the table
                    $.each($rows, function (index, row) {
                        $tbody.append(row);
                        row.sortKey = null;
                    });

                    //identify the collumn sort order
                    $this.closest('table').find('th').removeClass('sorted-asc sorted-desc');
                    $this.closest('table').find('th.sortable').addClass('sort-default');
                    const $sortHead = $this
                        .closest('table')
                        .find('th')
                        .filter(':nth-child(' + (column + 1) + ')');
                    $sortHead.removeClass('sort-default');

                    let unsortedElements = $('.table--sortable .sort-default').get();
                    unsortedElements.forEach(function (item, index) {
                        let sortDefaultElement = $(item);
                        let sortDefaultElementAtt = $(item).attr('aria-label');
                        if (sortDefaultElementAtt.indexOf(asc) > 0) {
                            let sortDefaultStr = sortDefaultElementAtt.replace(asc, '');
                            sortDefaultElement.attr('aria-label', sortDefaultStr);
                        }
                        if (sortDefaultElementAtt.indexOf(desc) > 0) {
                            let sortDefaultStr = sortDefaultElementAtt.replace(desc, '');
                            sortDefaultElement.attr('aria-label', sortDefaultStr);
                        }
                    });

                    sortDirection === 1 ? $sortHead.addClass('sorted-asc') : $sortHead.addClass('sorted-desc');
                    sortDirection === 1
                        ? $sortHead.attr('aria-label', `${ariaLabel} ${asc}`)
                        : $sortHead.attr('aria-label', `${ariaLabel} ${desc}`);
                    //identify the collum to be sorted by
                    $this
                        .closest('table')
                        .find('td')
                        .removeClass('sorted')
                        .filter(':nth-child(' + (column + 1) + ')')
                        .addClass('sorted');

                    if (sortableTable.$table.hasClass('js-pages')) {
                        sortableTable.pager.rebuild();
                    }

                    sortableTable.additionalClickTrigger();
                });
            });

            $('.sort-default').keydown(function (e) {
                if (e.keyCode === 13) {
                    $(this).trigger('click', true);
                    e.preventDefault();
                }
            });
        },
        additionalClickTrigger: function () {},
        pager: {
            rebuild: function () {
                var $pager = sortableTable.$table.find('.js-pager');
                var page = 0;
                var pageSize = sortableTable.$table.find('[data-page=1]').length;

                if (typeof $pager.attr('data-page-size') !== 'undefined') {
                    pageSize = $pager.attr('data-page-size');
                }

                sortableTable.$table.find('[data-page]').each(function (index) {
                    if (index % pageSize === 0) {
                        page++;
                    }
                    $(this).attr('data-page', page);
                });

                if (sortableTable.$table.find('.pagination__list').length) {
                    const activePage = sortableTable.$table.find('.pagination__list a.active').data('target-page');
                    sortableTable.$table.find('[data-page]').hide();
                    sortableTable.$table.find('[data-page=' + activePage + ']').show();
                }
            },
        },
        sortIt: function () {
            if (sortableTable.$table.length) {
                const $defaultSortItem = sortableTable.$table.find('th.default');

                for (let i = 0; i < $defaultSortItem.length; i++) {
                    const $sortableItem = $('[data-sort-order=' + i + ']'),
                        sortType = $sortableItem.data('sort-type');

                    $sortableItem.addClass('sorted-' + sortType).trigger('click');
                }
            }
        },
    };
    UX.sortableTable = sortableTable; // add to global namespace
})();
